import { Component } from '@angular/core';

@Component({
  selector: 'app-subfooter',
  templateUrl: './subfooter.component.html',
  styleUrls: ['./subfooter.component.css']
})
export class SubFooterComponent   {
  test : Date = new Date();

}
